import { ApolloClient, ApolloProvider } from '@apollo/client'
import { withProfiler } from '@sentry/react'
import { BrowserRouter } from 'react-router-dom'
import { ToastProvider } from 'react-toast-notifications'
import { MainDisplay } from 'src/applications/Embed/elements/LayoutElements'
import { sentryInit } from 'src/applications/Embed/lib/sentry.init'
import { DeveloperMenu } from 'src/applications/Oversight/developer/DeveloperMenu'
import { ErrorContext } from 'src/contexts/ErrorContext'
import { FileUploadProvider } from 'src/contexts/FileUploadContext'
import { TableValidationStateProvider } from 'src/contexts/TableValidationContext'
import { ErrorCapture, graphClient } from 'src/resources/clients/graphClient'
import { ToastContainer } from 'src/resources/elements/Toast'
import { Reset } from 'src/resources/Reset'
import { Analytics } from 'src/resources/utils/analytics'

import { EmbedController } from './EmbedController'
import i18n from './i18n'

import posthog from 'posthog-js'
import { env } from 'src/env'
import { I18nextProvider } from 'react-i18next'
import { Suspense } from 'react'

// error monitoring and such things
sentryInit()

if (env.POST_HOG_API_KEY && env.POST_HOG_HOST) {
  posthog.init(env.POST_HOG_API_KEY, { api_host: env.POST_HOG_HOST })
  posthog.capture('$pageview')
}

export const EmbedApp = withProfiler(() => (
  <>
    <MainDisplay>
      <ErrorContext>
        <ApolloProvider client={graphClient as ApolloClient<any>}>
          <ToastProvider placement='top-center' components={{ ToastContainer }}>
            <TableValidationStateProvider>
              <FileUploadProvider>
                <BrowserRouter>
                  <I18nextProvider i18n={i18n}>
                    <Suspense fallback='...'>
                      <EmbedController />
                    </Suspense>
                  </I18nextProvider>
                  <Analytics />
                  <ErrorCapture />
                  <Reset />
                </BrowserRouter>
              </FileUploadProvider>
            </TableValidationStateProvider>
          </ToastProvider>
          <DeveloperMenu />
        </ApolloProvider>
      </ErrorContext>
    </MainDisplay>
  </>
))
